import useWindowSize from '@customHooks/useWindowSize';
import AccountBtnDesktop from './Desktop';
import HeaderAvatar from './HeaderAvatar';

const AccountBtn = () => {
  const { isMobile, isTablet, isDesktop } = useWindowSize();
  if (isMobile) {
    return <HeaderAvatar />;
  } else if (isTablet || isDesktop) {
    return <AccountBtnDesktop />;
  } else {
    return null;
  }
};

export default AccountBtn;
